import { render, staticRenderFns } from "./GasDecicePriceAddView.vue?vue&type=template&id=b662fa38&scoped=true&"
import script from "./GasDecicePriceAddView.vue?vue&type=script&lang=js&"
export * from "./GasDecicePriceAddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b662fa38",
  null
  
)

export default component.exports